import styled from 'styled-components';
import Button from '../Button';

export const Cancel = styled(Button)`
  max-width: 220px;
  color: #8293a4;
  border: 2px solid ${(props) => props.theme.colors.pictonGrey};
  margin-right: 5px;

  &:hover:enabled {
    background: transparent;
    border-color: ${(props) => props.theme.colors.pictonGrey};
    color: ${(props) => props.theme.colors.pictonGrey};
  }

  &:disabled {
    opacity: 0.7;
  }
`;

export const Submit = styled(Button)`
  max-width: 220px;
  background: ${(props) => props.theme.colors.pictonGrey};
  color: white;
  margin-left: 5px;

  &:disabled {
    opacity: 0.7;
    background: #fff;
    color: #8293a4;
    border: 2px solid ${(props) => props.theme.colors.regent};
  }
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 40px;
  border-top: 1px solid rgba(130, 147, 164, 0.4);
`;

export const Description = styled.div`
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.03em;
  color: ${(props) => props.theme.colors.elephant};
  padding: 20px 40px;
  text-align: center;
`;

export const DescriptionWithoutHeader = styled.div`
  flex: 1;
  text-align: center;
  padding: 45px 40px;
  font-family: ${(props) => props.theme.fonts.regular};
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.03em;

  @media (max-width: 768px) {
    padding: 20px 20px;
    font-size: 16px;
    line-height: 19px;
  }
`;
